module.exports = __webpack_public_path__ + "static/media/IMG_0064.4eb5db66.jpg";